<div class="category">
  <div class="vis">
    <app-image [src]="imageThumb()" />
  </div>
  <p class="label">{{ name() }}</p>
</div>
